import { render } from "./EditForeignOffice.vue?vue&type=template&id=0dc1e260&scoped=true"
import script from "./EditForeignOffice.vue?vue&type=script&lang=js"
export * from "./EditForeignOffice.vue?vue&type=script&lang=js"

import "./EditForeignOffice.vue?vue&type=style&index=0&id=0dc1e260&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc1e260"]])

export default __exports__